import ApiCalls from "../util/ApiCalls";

class ReportsService {
    async generate(reportRequestDto) {
        return ApiCalls.defaultPost("/reports/generate", {}, reportRequestDto);
    }
}

export default new ReportsService();